import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/group.svg',
})
export class GroupComponent {}
